export default {"src":"/_next/static/media/GS-Logo-Outline.11038368.svg","height":48,"width":112,"blurWidth":0,"blurHeight":0};